'use client';

import { Provider } from 'react-redux';
import { store } from '../store';
import { ReactNode, useEffect, Suspense } from 'react';
import { setupListeners } from '@reduxjs/toolkit/query';
import { UserProfileLoader } from './UserProfileLoader';
// import { conversationSubscriptionsApi } from '@/api/features/conversations/subscriptions';

interface ReduxProviderProps {
  children: ReactNode;
}

export function ReduxProvider({ children }: ReduxProviderProps) {
  useEffect(() => {
    // Setup listeners for RTK Query - enables refetchOnFocus and other useful features
    const unsubscribe = setupListeners(store.dispatch);
    
    // Initialize conversation subscription manager
    // WebSocket subscriptions are now handled by RTK Query patterns
    
    return () => {
      unsubscribe();
    };
  }, []);
  
  return (
    <Provider store={store}>
      {/* Wrap UserProfileLoader in Suspense to fix Next.js 16 Date.now() warning */}
      <Suspense fallback={null}>
        <UserProfileLoader />
      </Suspense>
      {children}
    </Provider>
  );
} 